import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logSponsoredListCarouselDisplayedParams = {
  carousel_length?: number;
  location: CardLocation;
};

/**
 * a carousel that contains sponsored lists is displayed to user.
 * @param params - Attributes to log with the amplitude event
 * @param params.carousel_length - Total number of cards in the carousel.
 * @param params.location - The location of the sponsored list carousel
 */
const logSponsoredListCarouselDisplayed = ({ carousel_length, location }: logSponsoredListCarouselDisplayedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('sponsored list carousel displayed', { 'carousel length': carousel_length, location }, callback);
};

export default logSponsoredListCarouselDisplayed;
